import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M2.729 5.9h27.54v18.212c0 .49-.398.888-.889.888H3.617a.89.89 0 0 1-.888-.888z"
    />
    <path
      fill="#C2C8D3"
      fillRule="evenodd"
      d="M29.825 6.344H3.173v17.768c0 .245.2.444.444.444H29.38a.444.444 0 0 0 .445-.444zM2.729 5.9v18.212c0 .49.398.888.888.888H29.38a.89.89 0 0 0 .889-.888V5.9z"
      clipRule="evenodd"
    />
    <path
      fill="#729FF9"
      d="M2.729 3.725c0-.4.324-.725.724-.725h26.09c.4 0 .725.324.725.725v2.174H2.728z"
    />
    <path
      fill="#E0E3E9"
      d="M2.729 11.986c0-.16.13-.29.29-.29h26.96c.16 0 .29.13.29.29v.145c0 .16-.13.29-.29.29H3.019a.29.29 0 0 1-.29-.29zm0 6.524c0-.16.13-.29.29-.29h26.96c.16 0 .29.13.29.29v.145c0 .16-.13.29-.29.29H3.019a.29.29 0 0 1-.29-.29z"
    />
    <path
      fill="#E0E3E9"
      d="M11.546 24.743a.29.29 0 0 1-.29-.29V6.19c0-.16.13-.29.29-.29h.145c.16 0 .29.13.29.29v18.263c0 .16-.13.29-.29.29zm9.506 0a.29.29 0 0 1-.29-.29V6.19c0-.16.13-.29.29-.29h.145c.16 0 .29.13.29.29v18.263c0 .16-.13.29-.29.29z"
    />
    <path
      stroke="#C2C8D3"
      strokeWidth={0.444}
      d="M2.952 6.122h27.096v17.99a.666.666 0 0 1-.667.666H3.618a.666.666 0 0 1-.666-.666z"
    />
  </svg>
);
export default SvgTable;
